import { Button, Modal } from "antd";
import { AIQuestionGroup, AIQuestionItem } from "paper-splitter/interfaces";
import React from "react";
import { DraggableTable } from "../DraggableTable";
import { ReloadOutlined } from "@ant-design/icons";

type QuestionGroupModalProps = {
  card: AIQuestionGroup;
  modalOpen: boolean;
  refreshing: boolean;
  onOpen: (open: boolean) => void;
  updateQuestions: (questions: AIQuestionItem[]) => void;
  fetchQuestionGroups: () => void;
};

export const QuestionGroupModal: React.FC<QuestionGroupModalProps> = ({
  card,
  modalOpen,
  refreshing,
  onOpen,
  updateQuestions,
  fetchQuestionGroups,
}) => {
  return (
    <Modal
      open={modalOpen}
      onCancel={() => onOpen(false)}
      footer={null}
      width={800}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: 30,
          }}
        >
          <span>{card.topic.name}</span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            
            <span
              style={{
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              Points:{" "}
              {card?.questions.reduce(
                (sum, item) => sum + (item.points_possible || 0),
                0
              )}
            </span>
            <Button
              icon={<ReloadOutlined spin={refreshing} />}
              onClick={() => fetchQuestionGroups()}
              loading={refreshing}
            />
          </div>
        </div>
      }
    >
      {card.questions.length > 0 ? (
        <DraggableTable
          data={card.questions ?? []}
          onDataChange={updateQuestions}
        />
      ) : (
        <span style={{ color: "#aaa" }}>No questions chosen</span>
      )}
    </Modal>
  );
};
